import cloneDeep from 'lodash/cloneDeep';

import {
  SAVING_ASSIGNEMENT,
  SAVED_ASSIGNEMENT,
  SAVE_ASSIGNEMENT_ERROR,
  DELETING_ASSIGNEMENT,
  DELETE_ASSIGNEMENT_ERROR,
  VALIDATION_ERROR,
  USER_ASSIGNMENTS__FETCH,
  DATA_LOADING,
  DATA_ERROR,
  UPDATING_PHI_CONSENT,
  UPDATE_PHI_CONSENT,
  UPDATING_PHI_CONSENT_FAILED,
  LOGGED_USER_FETCH
} from '../actions/actionTypes';

const assignmentsInit = {
  assignmentSaving: false,
  assignment: null,
  userAssignments: null,
  error: null,
  isFetching: null,
  validationError: null,
  isUpdatingPhiConsent: false,
  loggedUser: null
};

const updateAssignments = (userAssignments, payload) => {
  let assignments = cloneDeep(userAssignments);
  const { canObtainIc, canViewPhi, assignmentId, version } = payload.data;

  assignments.data.assignments.data.find((assignment) => {
    if (assignment.assignmentId === assignmentId) {
      assignment.canObtainIc = canObtainIc;
      assignment.canViewPhi = canViewPhi;
      assignment.version = version;

      return true;
    }
  });

  return assignments;
};

const assignmentsReducer = (state = assignmentsInit, action) => {
  switch (action.type) {
    case SAVING_ASSIGNEMENT:
      return Object.assign({}, state, { assignmentSaving: true, assignment: null, error: null, validationError: null });
    case SAVED_ASSIGNEMENT:
      return Object.assign({}, state, { assignmentSaving: false, assignment: action.payload, error: null });
    case SAVE_ASSIGNEMENT_ERROR:
      return Object.assign({}, state, { assignmentSaving: false, error: action.payload });
    case DELETING_ASSIGNEMENT:
      return Object.assign({}, state, { isFetching: action.payload, error: null, validationError: null });
    case DELETE_ASSIGNEMENT_ERROR:
      return Object.assign({}, state, { isFetching: false, error: action.payload });
    case DATA_ERROR:
      return Object.assign({}, state, { isFetching: false, error: action.payload });
    case DATA_LOADING:
      return Object.assign({}, state, { isFetching: true });
    case USER_ASSIGNMENTS__FETCH:
      return Object.assign({}, state, { isFetching: false, userAssignments: action.payload });
    case LOGGED_USER_FETCH:
      return Object.assign({}, state, { loggedUser: action.payload.data.assignments.data });
    case VALIDATION_ERROR:
      return Object.assign({}, state, { validationError: action.payload });
    case UPDATING_PHI_CONSENT:
      return Object.assign({}, state, { isUpdatingPhiConsent: true });
    case UPDATE_PHI_CONSENT:
      return Object.assign({}, state, {
        isUpdatingPhiConsent: false,
        userAssignments: updateAssignments(state.userAssignments, action.payload)
      });
    case UPDATING_PHI_CONSENT_FAILED:
      return Object.assign({}, state, { isUpdatingPhiConsent: false });
    default:
      return state;
  }
};

export default assignmentsReducer;
